import $ from 'jquery';

export default () => {
  var screenChange = 1120;
  var openClass = 'nav-menu-open';

  $('.nav-menu').hover(
    function() {
      if ($(window).width() > screenChange) {
        $('.nav-menu')
          .not(this)
          .find('ul')
          .hide();
        $(this)
          .stop()
          .find('ul')
          .slideDown('medium');
        $(this)
          .find('ul')
          .css(
            'min-width',
            $(this)
              .find('a:first')
              .width() + 'px'
          );
        $(this).addClass('nav-menu-hovered');
      }
    },
    function() {
      if ($(window).width() > screenChange) {
        $(this)
          .find('ul')
          .hide();
        $(this).removeClass('nav-menu-hovered');
      }
    }
  );

  $('.nav-menu .nav-menu-trigger').on('click', function() {
    var $thisp = $(this).parent();
    if ($(window).width() <= screenChange && $thisp.find('ul').length > 0) {
      $thisp.toggleClass(openClass);
      return false;
    }
  });

  var removeNavClass = function() {
    if ($(window).width() > screenChange) {
      $('.nav-menu')
        .removeClass(openClass)
        .css('width', 'auto');
      $('.nav-menu')
        .find('ul')
        .hide();
      $('.nav-menu').removeClass('nav-menu-hovered');
    }
  };
  window.addEventListener('resize', removeNavClass);

  var navSearchFormOpener = $('.nav__search-form-control-opener');

  var $newHeader = $('.newheader');

  navSearchFormOpener.on('click', function() {
    if ($newHeader.hasClass('desktop-search')) {
      $('.nav__search-form').slideToggle('slow', function() {
        $newHeader.removeClass('desktop-search');
      });
    } else {
      $newHeader.toggleClass('desktop-search');
      $('.nav__search-form').slideToggle('slow');
    }
    return false;
  });

  var navMenuAccount = $('.nav-menu-account');

  if (navMenuAccount.length > 0) {
    navMenuAccount.hover(
      function() {
        if ($(window).width() > screenChange) {
          $(this)
            .find('ul')
            .stop()
            .slideDown();
          if ($(window).width() <= screenChange) {
            $(this).addClass('nav-menu-account-hover');
          }
        }
      },
      function() {
        if ($(window).width() > screenChange) {
          $(this)
            .find('ul')
            .stop()
            .hide();
          if ($(window).width() <= screenChange) {
            $(this).removeClass('nav-menu-account-hover');
          }
        }
      }
    );

    $('.ss-user-name').on('click', function() {
      if ($(window).width() <= screenChange) {
        navMenuAccount.find('ul').slideToggle();
        navMenuAccount.toggleClass('nav-menu-account-hover');
      }
      return false;
    });
  }

  $('.newheader__nav-menu-control').on('click', function() {
    $('.newheader').removeClass('desktop-search');
    $('body').addClass('mobile-nav-open');
    $('.nav__mobile-wrap').scrollTop(0);
    return false;
  });

  $('.nav__mobile-wrap-close').on('click', function() {
    $('.newheader').removeClass('desktop-search');
    $('.nav__search-form').hide();
    $('body').removeClass('mobile-nav-open');
    return false;
  });

  if ($(window).width() <= screenChange) {
    var socialIcon = $(
      '<div class="newheader__mobile__social"> <a class="subscribe__mag" href="https://www.themagazineshop.com/what-car/" target="_blank">Subscribe to What Car? magazine</a> <a class="subscribe__news" href="http://pages.haymarket.com/whatcar/wcar-form.html" target="_blank">Subscribe to our newsletter</a> <a class="social__fb" href="https://www.facebook.com/whatcar/" target="_blank"> Facebook</a> <a class="social__tw" href="https://twitter.com/whatcar" target="_blank"> Twitter</a> <a class="social__yt" href="https://www.youtube.com/user/whatcar" target="_blank"> YouTube</a> </div>'
    );
    $(socialIcon).insertAfter('ul.newheader__nav-menu');

    var navControl;

    var vP = '';

    if (window.location.href.indexOf('whatcar.com/valuations') > -1) {
      vP = '/valuations';
    }

    if ($('.ss-user-name').length) {
      var name = $('.ss-user-name strong').text();
      var nameLetter =
        name.charAt(0).toUpperCase() + name.charAt(1).toUpperCase();

      navControl =
        '<div class="mobile__user-account"> <a href="' +
        vP +
        '/profile"><span class="mobile__user-account-initials">' +
        nameLetter +
        '</span></a> <div class="mobile__user-account-user"> <div class="mobile__user-account-name"><a href="' +
        vP +
        '/profile">' +
        name +
        '</a></div><div class="mobile__user-account-email"><a href="' +
        vP +
        '/logout">Sign out</a></div><a href="' +
        vP +
        '/profile" class="mobile__user-account-account"></a></div><a class="mobile__user-my-account" href="' +
        vP +
        '/profile"></a></div>';
    } else {
      navControl =
        '<div class="mobile__user-account"><div class="mobile__user-account-user"><div class=""><a href="' +
        vP +
        '/sign-in">Sign in</a></div></div></div>';
    }

    $(navControl).insertAfter('.newheader__mobile__social');

    $('.nav-mobile-menu-open').addClass('nav-menu-open');
  }
};



// WEBPACK FOOTER //
// ./src/App/client/external/header.js